import { FilterToTypes } from '../../constants/filter/filter_to_types';

function getTypeByFilter(filterName) {
    return FilterToTypes[filterName];
}

export { getTypeByFilter };